import React, { FC, ReactElement, useCallback, useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";

//types import
import { ScreenType } from "Constants";

//@ts-ignore
import sessionStorage from 'store/storages/sessionStorage';

//styles
import "./styles.sass";

import LocalizationService from "Services/localization.service";
import MvLink from "Generic/MvLink";
import { showPlacement, terminateRokt } from "Components/rokt/RoktLauncherContext";
import { convertAlpha3ToAlpha2, getLanguagePreference, getStoredCountry, getStoredEmail, getStoredFirstName, getStoredLastName } from "Components/rokt/HelperMethods";

type Props = {
    token: string;
    lang: string;
    setScreenType(screenType: ScreenType): void;
}

const TransferPointConfirmation: FC<any> = (props: Props): ReactElement => {
    const { localize } = useContext(LocalizationContext);
    const localizationService: LocalizationService = new LocalizationService();
    const [isMobile, setIsMobile] = useState(false);
    const roktSelectionRef = useRef<any|null>(null);

    //<p>Once complete, you&rsquo;ll receive an email confirming your transfer has been deposited into the Owner&rsquo;s account. As a reminder, this process could take up to 3 days.</p>
    const bodyString: string = localize("static.content.transfer-points-success-confirmation").replace("<p>", "").replace("&rsquo;", "'").replace("&rsquo;", "'").replace("</p>", "");

    useEffect(() => {
        setIsMobile(window.screen.width <= 480);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.onresize = () => {
            if (window.screen.width <= 480 && !isMobile) {
                setIsMobile(true);
            }
            else if (window.screen.width > 480 && isMobile) {
              setIsMobile(false);
            }
          }
          
    }, [])

    useEffect(()=>{
const attributes={
            email: getStoredEmail(),
            firstname: getStoredFirstName(),
            lastname: getStoredLastName(),
            //confirmationref:"", // this field is not available for this page
            country: convertAlpha3ToAlpha2(getStoredCountry()||""),
            language: getLanguagePreference()
        }
    
        showPlacement(attributes)
      .then((selection) => {
        roktSelectionRef.current = selection;
        // You can now access this in future renders as roktSelectionRef.current
      })
      .catch((error) => {
        console.error("ROKT placement failed", error);
      });
      return () => {
        if (roktSelectionRef.current) {
          roktSelectionRef.current.close();
        }
        terminateRokt();
      };
    },[])

    function goToUsageOptions() {
        window.open('/timeshare/mvco/points/usageoptions', '_self');
    }

    return (
        <div className="transfer-point-confirmation-page">
            <div id="rokt-placeholder"></div>
            <div><img src={isMobile ? localize('static.content.transfer-points-success-image-mobile') : localize('static.content.transfer-points-success-image-desktop')} alt='' style={{ width: '100%' }} /></div>
            <br/>
            <h3 className="transfer-point-confirmation-page-title">{localize("static.content.transfer-points-request-received")}</h3>
            <br/>
            <p className="transfer-point-confirmation-page-body">{bodyString}</p>
            <br/>
            <div className="transfer-point-link">
                <MvLink label={localize("static.content.transfer-points-more-usage-option")} onClick={() => goToUsageOptions()} />
            </div>
        </div>);
}

TransferPointConfirmation.contextTypes = LocalizationContext;
export {
    TransferPointConfirmation,
};